import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-dialog',
  template: `
    <div class="sheet-body confirm-body">
      <h2 class="confirm-title">{{ title }}</h2>
      <p class="confirm-message" *ngIf="message">{{ message }}</p>
    </div>
    <div class="sheet-footer">
      <span class="spacer"></span>
      <button type="button" class="btn btn-quiet" (click)="modal.close(false)">Cancel</button>
      <button type="button" class="btn" ngbAutofocus
              [class.btn-danger]="danger" [class.btn-brand]="!danger"
              (click)="modal.close(true)">{{ confirmLabel }}</button>
    </div>
  `,
  styles: [`
    .confirm-title { font-size: 1.1rem; font-weight: 700; margin: 0 0 0.4rem; }
    .confirm-message { margin: 0; color: var(--muted); }
    .sheet-footer .btn { flex: 0 0 auto; }
  `],
  standalone: false
})
export class ConfirmDialogComponent {
  @Input() title = 'Are you sure?';
  @Input() message?: string;
  @Input() confirmLabel = 'Confirm';
  @Input() danger = false;

  constructor(public modal: NgbActiveModal) {
  }
}
